import { Table } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useBreakpoint } from '@app/hooks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  getCustomRenderers,
  getPartSchema,
  ALTERNATIVES,
  ORIGINAL
} from '../utils';
import styles from './styles.modules.scss';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { cartItemPropType } from '../declarations.propTypes';
import Conditional from '@app/components/common/Conditional';

const AlternativePartsTable = ({
  sequence,
  currency,
  item,
  alternateParts,
  quantities,
  showQuantityError,
  setQuantities,
  isAvailabilityToggled = false
}) => {
  const [t] = useTranslation();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);

  const isStoreAvailabilityEnabled = useSelector(
    s => s.dealer?.isStoreAvailabilityEnabled
  );
  const isQuantityMergeEnabled = useSelector(
    s => s?.common?.isQuantityMergeEnabled
  );
  const hoseAvailabilityLabel = useSelector(
    s => s.common?.hoseAvailabilityLabel
  );
  const isDeliveryEnabled = useSelector(
    state => state.common.isDeliveryEnabled
  );
  const isPickUpEnabled = useSelector(state => state.dealer.isPickupEnabled);
  const setQuantity = (referenceId, quantity) =>
    setQuantities(q => ({
      ...q,
      [item.referenceId]: {
        ...q[item.referenceId],
        [referenceId]: quantity
      }
    }));

  const getData = (data, isOriginal = false) =>
    data?.map((opt, idx) => ({
      ...opt,
      ...(isOriginal ? { sequence } : { id: idx }),
      item: `${opt.partNumber}: ${opt.partName}`,
      unitPrice: opt?.price?.formatted?.unitPrice ?? '',
      typeElement: isOriginal ? ORIGINAL : ALTERNATIVES,
      displayAvailabityAndSourcingDetails: isAvailabilityToggled
    }));

  const customRenderers = getCustomRenderers(
    currency,
    alternateParts,
    isStoreAvailabilityEnabled,
    isAvailabilityToggled,
    hoseAvailabilityLabel,
    quantities,
    setQuantity,
    showQuantityError,
    t
  );

  return (
    <div
      key={item.id}
      className={`${styles['remove-border-bottom']} px-2 pt-0`}
    >
      <Table
        keyGenerator={itemPart => `${itemPart.partNumber}`}
        schema={getPartSchema(
          currency,
          t,
          isQuantityMergeEnabled,
          true,
          isDeliveryEnabled,
          isPickUpEnabled
        )}
        data={getData([item], true)}
        customRenderers={customRenderers}
      />
      <Conditional test={isLG}>
        <p
          className={`${styles['alternative-subtitle-text']} text-start mb-2 text-uppercase u-color--ExtraDarkGray text-univers--bold u-fs--16 border-top`}
        >
          {t('AVAILABLE_ALTERNATIVES')}
        </p>
        <Table
          keyGenerator={itemPart => `${itemPart.partNumber}`}
          schema={getPartSchema(
            currency,
            t,
            isQuantityMergeEnabled,
            false,
            isDeliveryEnabled,
            isPickUpEnabled
          )}
          data={getData(alternateParts)}
          customRenderers={customRenderers}
        />
      </Conditional>
    </div>
  );
};

AlternativePartsTable.propTypes = {
  item: cartItemPropType,
  currency: PropTypes.string,
  sequence: PropTypes.string,
  alternateParts: PropTypes.arrayOf(cartItemPropType),
  quantities: PropTypes.objectOf(PropTypes.number),
  showQuantityError: PropTypes.func,
  setQuantities: PropTypes.func,
  isAvailabilityToggled: PropTypes.bool
};
export default AlternativePartsTable;
